import { render, staticRenderFns } from "./descriptionList.vue?vue&type=template&id=0b4eea06&"
import script from "./descriptionList.vue?vue&type=script&lang=js&"
export * from "./descriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4eea06')) {
      api.createRecord('0b4eea06', component.options)
    } else {
      api.reload('0b4eea06', component.options)
    }
    module.hot.accept("./descriptionList.vue?vue&type=template&id=0b4eea06&", function () {
      api.rerender('0b4eea06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/description/descriptionList.vue"
export default component.exports